import React from "react";
import { Card } from "react-bootstrap";

const SKELETON_COLS = 6;
const SKELETON_ROWS = 8;

const SkeletonGrid: React.FC = () => {
  return (
    <Card>
      <Card.Body style={{ padding: 0, overflow: "hidden" }}>
        <table className="grid-report-table">
          <thead>
            <tr>
              <th className="grid-report-corner-cell">
                <div className="skeleton-bar" style={{ width: 80 }} />
              </th>
              {Array.from({ length: SKELETON_COLS }).map((_, i) => (
                <th key={i} className="grid-report-col-header">
                  <div className="skeleton-bar" style={{ width: 60 + Math.random() * 40 }} />
                </th>
              ))}
              <th className="grid-report-col-header grid-report-total-header">
                <div className="skeleton-bar" style={{ width: 40 }} />
              </th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: SKELETON_ROWS }).map((_, yIdx) => (
              <tr key={yIdx}>
                <td className="grid-report-row-header">
                  <div className="skeleton-bar" style={{ width: 70 + Math.random() * 60 }} />
                </td>
                {Array.from({ length: SKELETON_COLS }).map((_, xIdx) => (
                  <td key={xIdx} style={{ textAlign: "right", padding: "4px 8px" }}>
                    <div className="skeleton-bar skeleton-bar-num" />
                  </td>
                ))}
                <td style={{ textAlign: "right", padding: "4px 8px", background: "var(--surface-page)" }}>
                  <div className="skeleton-bar skeleton-bar-num" />
                </td>
              </tr>
            ))}
            {/* Totals row */}
            <tr className="grid-report-total-row">
              <td className="grid-report-row-header" style={{ fontWeight: 700 }}>
                <div className="skeleton-bar" style={{ width: 50 }} />
              </td>
              {Array.from({ length: SKELETON_COLS }).map((_, xIdx) => (
                <td key={xIdx} style={{ textAlign: "right", padding: "4px 8px" }}>
                  <div className="skeleton-bar skeleton-bar-num" />
                </td>
              ))}
              <td style={{ textAlign: "right", padding: "4px 8px" }}>
                <div className="skeleton-bar skeleton-bar-num" />
              </td>
            </tr>
          </tbody>
        </table>
      </Card.Body>
    </Card>
  );
};

export default SkeletonGrid;
